import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomSelect } from './CustomSelect';
import { SectionHeader } from '../SectionHeader';
import { useState } from 'react';
import axios from '../../../util/Axios';

const wide = '360px';

export function EditNihssExamination({ nihss, onCancel, onSaved, testId }) {
  const [item1A, setItem1A] = useState(nihss?.item1A != null ? nihss?.item1A : -1);
  const [item1B, setItem1B] = useState(nihss?.item1B != null ? nihss?.item1B : -1);
  const [item1C, setItem1C] = useState(nihss?.item1C != null ? nihss?.item1C : -1);
  const [item2, setItem2] = useState(nihss?.item2 != null ? nihss?.item2 : -1);
  const [item3, setItem3] = useState(nihss?.item3 != null ? nihss?.item3 : -1);
  const [item4, setItem4] = useState(nihss?.item4 != null ? nihss?.item4 : -1);
  const [item4Side, setItem4Side] = useState(nihss?.item4Side != null ? nihss?.item4Side : -1);
  const [item5A, setItem5A] = useState(nihss?.item5A != null ? nihss?.item5A : -1);
  const [item5B, setItem5B] = useState(nihss?.item5B != null ? nihss?.item5B : -1);
  const [item6A, setItem6A] = useState(nihss?.item6A != null ? nihss?.item6A : -1);
  const [item6B, setItem6B] = useState(nihss?.item6B != null ? nihss?.item6B : -1);
  const [item7, setItem7] = useState(nihss?.item7 != null ? nihss?.item7 : -1);
  const [item8, setItem8] = useState(nihss?.item8 != null ? nihss?.item8 : -1);
  const [item9, setItem9] = useState(nihss?.item9 != null ? nihss?.item9 : -1);
  const [item10, setItem10] = useState(nihss?.item10 != null ? nihss?.item10 : -1);
  const [item11, setItem11] = useState(nihss?.item11 != null ? nihss?.item11 : -1);

  const { t } = useTranslation();

  const renderNihssItem = (itemCode, val, setVal, optionSize) => {
    return (
      <>
        <CustomSelect value={val} valueChanged={setVal} label={t(`nihss${itemCode}Title`)} values={buildOptionList(`nihss${itemCode}`, optionSize)} width={wide} />
      </>
    );
  };

  const renderNihssItem4Side = (itemCode, val, setVal) => {
    const options = [];

    options.push({ value: -1, name: t(`Please select`) });
    options.push({ value: 'LEFT', name: 'Left' });
    options.push({ value: 'RIGHT', name: 'Right' });
    return (
      <>
        <CustomSelect value={val} valueChanged={setVal} label={t(`Facial Palsy Side`)} values={options} width={wide} />
      </>
    );
  };

  const buildOptionList = (itemName, count) => {
    const options = [];
    options.push({ value: -1, name: t(`Please select`) });
    for (let i = 0; i < count; i++) {
      options.push({ value: i, name: t(`${itemName}${i}`) });
    }
    return options;
  };

  const save = () => {
    const nihssToSave = {
      item1A: item1A,
      item1B: item1B,
      item1C: item1C,
      item2: item2,
      item3: item3,
      item4: item4,
      item4Side: item4Side,
      item5A: item5A,
      item5B: item5B,
      item6A: item6A,
      item6B: item6B,
      item7: item7,
      item8: item8,
      item9: item9,
      item10: item10,
      item11: item11,
    };

    axios(`/strokeTests/${testId}/nihssExamination`, {
      method: 'PUT',
      data: nihssToSave,
    }).then(() => onSaved(nihssToSave), onCancel);
  };

  return (
    <>
      <Stack>
        <SectionHeader name="NIHSS Examination" />
        {renderNihssItem('1A', item1A, setItem1A, 5)}
        {renderNihssItem('1B', item1B, setItem1B, 5)}
        {renderNihssItem('1C', item1C, setItem1C, 3)}
        {renderNihssItem('2', item2, setItem2, 4)}
        {renderNihssItem('3', item3, setItem3, 5)}
        {renderNihssItem('4', item4, setItem4, 5)}
        {item4 > 0 ? renderNihssItem4Side('4Side', item4Side, setItem4Side) : ''}
        {renderNihssItem('5A', item5A, setItem5A, 7)}
        {renderNihssItem('5B', item5B, setItem5B, 7)}
        {renderNihssItem('6A', item6A, setItem6A, 7)}
        {renderNihssItem('6B', item6B, setItem6B, 7)}
        {renderNihssItem('7', item7, setItem7, 6)}
        {renderNihssItem('8', item8, setItem8, 6)}
        {renderNihssItem('9', item9, setItem9, 5)}
        {renderNihssItem('10', item10, setItem10, 4)}
        {renderNihssItem('11', item11, setItem11, 5)}

        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button onClick={onCancel}>Cancel</Button>
          <Button variant="contained" onClick={save}>
            {' '}
            Save{' '}
          </Button>
        </Stack>
      </Stack>
    </>
  );
}
